import $ from 'jquery';
const accordionMobile = () =>{
    if(document.querySelector('.ume-mitarbeiter-grid') || document.querySelector('.ume-singular-staff') || document.querySelector('.ume-projects-holder')){
        document.addEventListener('click', ev =>{
            if(!ev.target.matches('.ume-accordion-is-open-trigger')) return;
            const targetModal = document.querySelector(ev.target.getAttribute('data-target'));
            if(targetModal.querySelector('.ume-accordion-is-open')){
                if ($(window).width() > 769) {

                    const button = targetModal.querySelector('.ume-accordion-is-open');
                    if(button.classList.contains('collapsed')){
                        button.click();
                    }



                }

            }

        })
    }

}

export default accordionMobile;